import { matchPath } from 'react-router';
import { AppRoute } from '../routes';

export const getAppRoute = (pathname: string): AppRoute | undefined => {
  return Object.keys(AppRoute).find((key) => matchPath(key, pathname)) as
    | AppRoute
    | undefined;
};
